import { render, staticRenderFns } from "./SimpleCard.vue?vue&type=template&id=4f0584da&scoped=true&"
import script from "./SimpleCard.vue?vue&type=script&lang=ts&"
export * from "./SimpleCard.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleCard.vue?vue&type=style&index=0&id=4f0584da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0584da",
  null
  
)

export default component.exports